// Calendly configuration and helpers
export const CALENDLY_URL = 'https://calendly.com/outsourcedhub-info/30min?month=2026-07';

// Opens the Calendly scheduling popup. Falls back to a new tab if the widget
// script hasn't loaded yet.
export const openCalendly = () => {
  if (typeof window !== 'undefined' && window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    return false;
  }
  window.open(CALENDLY_URL, '_blank', 'noopener,noreferrer');
  return false;
};
